export const CHECKOUT_PAGE_TYPE = 'CheckOut';
export const CAMPAIGN_LIST_PAGE_TYPE = 'CampaignListPage';
export const PRODUCT_LIST_PAGE_TYPE = 'ProductListPage';
export const CAMPAIGN_PAGE_TYPE = 'CampaignPage';
export const NEWSLETTER_PAGE_TYPE = 'NewsletterSignupPage';



// WEBPACK FOOTER //
// ./src/constants/pageTypes.js